import _ from 'lodash';

import { Modals } from 'Pages/manageproduction/helpers/Constants';

import * as types from './types';

const INITIAL_STATE = Object.freeze({
  fetching: false,
  startFromIndex: 0,
  viewProdRecordIndex: 0,
  error: null,
  fetchingCloseProd: false,
  fetchingRecipeLeftovers: false,
  fetchingStartOver: false,
  saveSuccessful: false,
  closeSuccessful: false,
  startOverSuccessful: false,
  temperatures: [''],
  loadedRecordsMap: {},
  expandedRecipesByProdRecord: {},
  recipeLeftovers: [],
  prodRecords: [],
  initialProdRecords: [],
  [Modals.ProductionPlan]: false,
  [Modals.Print]: false,
  [Modals.Close]: false,
});

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.EDIT_PRODUCTION_START_OVER_SUCCESS:
      return { ...state, startOverSuccessful: payload };
    case types.EDIT_PRODUCTION_START_OVER_LOADING:
      return { ...state, fetchingStartOver: payload };
    case types.EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING:
      return { ...state, fetchingCloseProd: payload };
    case types.EDIT_PRODUCTION_FETCHING_PRODUCTION_RECORDS:
      return { ...state, fetching: payload };
    case types.EDIT_PRODUCTION_RECIPE_LEFTOVERS_LOADING:
      return { ...state, fetching: payload };

    case types.EDIT_PRODUCTION_SET_START_FROM_INDEX:
      return { ...state, startFromIndex: payload };

    case types.EDIT_PRODUCTION_SET_VIEW_PROD_RECORD_INDEX:
      return { ...state, viewProdRecordIndex: payload };

    case types.EDIT_PRODUCTION_SET_TEMPERATURES:
      return { ...state, temperatures: payload };

    case types.EDIT_PRODUCTION_SET_LOADED_RECORDS_MAP:
      return { ...state, loadedRecordsMap: payload };

    case types.EDIT_PRODUCTION_SET_EXPANDED_RECIPES_BY_PROD_RECORD:
      return { ...state, expandedRecipesByProdRecord: payload };

    case types.EDIT_PRODUCTION_SET_RECIPE_LEFTOVERS:
      return { ...state, recipeLeftovers: payload };

    case types.EDIT_PRODUCTION_SET_SAVE_PRODUCTION_RECORDS_SUCCESS:
      return { ...state, saveSuccessful: payload };
    case types.EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS:
      return { ...state, closeSuccessful: payload };
    case types.EDIT_PRODUCTION_START_OVER_ERROR:
    case types.EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR:
    case types.EDIT_PRODUCTION_RECIPE_LEFTOVERS_ERROR:
    case types.EDIT_PRODUCTION_SET_ERROR:
      return { ...state, error: payload };

    case types.EDIT_PRODUCTION_CLEAR_ERROR:
      return { ...state, error: null };

    case types.EDIT_PRODUCTION_CLEAR_STATE:
      return INITIAL_STATE;

    case types.EDIT_PRODUCTION_FORM_INITIALIZE: {
      const { viewProdRecordIndex, prodRecords, startFromIndex } = payload;

      return {
        ...state,
        viewProdRecordIndex,
        prodRecords,
        initialProdRecords: _.cloneDeep(prodRecords),
        startFromIndex,
      };
    }

    case types.EDIT_PRODUCTION_CHANGE_MODAL_VISIBILITY: {
      const { modal, show } = payload;

      return { ...state, [modal]: show };
    }

    case types.EDIT_PRODUCTION_UPDATE_PRODUCTION_PLAN: {
      const { prodRecords } = payload;

      return { ...state, prodRecords };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/editproduction/reducer.js